"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgo-d-anaunia": {
    "37ccd439": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "cologna": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b88a422": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "la-villa": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "294c4533": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "plaz": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1e730d8": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "plaze": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;